import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCannabis, faSeedling } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <section className="relative py-24 px-6 bg-black text-white text-center overflow-hidden">
      <div className="container mx-auto relative z-10">
        {/* Title with Neon Glow */}
        <motion.h2
          className="text-4xl lg:text-5xl font-extrabold mb-6 text-green-400 drop-shadow-[0_0_12px_rgba(34,197,94,0.8)]"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          Cultivate a Greener Future with Us
        </motion.h2>

        {/* Subtitle */}
        <p className="text-lg lg:text-xl max-w-3xl mx-auto mb-8 leading-relaxed text-gray-300">
          Every great journey starts with a single seed. Let’s plant the future
          together—sustainable, innovative, and thriving. Reach out today and
          let’s grow something extraordinary.
        </p>

        {/* Second CTA Button (Explore Cultivars) */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.5 }}
        >
          <Link
            to="/contact"
            className="mt-6 inline-block px-6 py-3 bg-green-400 text-black rounded-lg font-semibold text-lg hover:bg-green-500 transition duration-300"
          >
            <FontAwesomeIcon icon={faSeedling} className="mr-2 text-lg" />
            Let’s Connect & Grow
          </Link>
        </motion.div>
      </div>

      {/* Floating Decorative Green Glow Orbs */}
      <motion.div
        className="absolute top-12 left-12 w-16 h-16 bg-green-500 rounded-full opacity-30 blur-2xl"
        animate={{ x: [-15, 15, -10, 10], y: [-10, 10, -5, 5] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-12 right-12 w-24 h-24 bg-green-400 rounded-full opacity-40 blur-3xl"
        animate={{ x: [20, -20, 15, -5], y: [10, -10, 5, -5] }}
        transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }}
      />

      <motion.div
        className="absolute top-20 right-32 text-green-300 text-5xl opacity-70"
        animate={{ y: [0, -10, 10, -5, 0] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
      >
        <FontAwesomeIcon icon={faCannabis} />
      </motion.div>

      <motion.div
        className="absolute bottom-16 left-24 text-green-400 text-6xl opacity-80"
        animate={{ y: [0, 10, -10, 5, 0] }}
        transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
      >
        <FontAwesomeIcon icon={faCannabis} />
      </motion.div>
    </section>
  );
};

export default Cta;
